import { Circle, Line, Svg } from '../../compiler'
import { colors } from '../../constants'

const AVERAGE_ICON_SIZE = 16
const AVERAGE_ICON_HALF = AVERAGE_ICON_SIZE / 2

const AverageIcon = ({
  bottom,
  left,
  tooltipId,
  tooltipContent,
  tooltipPlace = 'top'
}) => {
  return (
    <div
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent}
      data-tooltip-place={tooltipPlace}
      style={{
        position: 'absolute',
        bottom,
        left,
        transform: `translate(-${AVERAGE_ICON_HALF}px, ${AVERAGE_ICON_HALF}px)`
      }}
    >
      <Svg
        xmlns='http://www.w3.org/2000/svg'
        width={AVERAGE_ICON_SIZE}
        height={AVERAGE_ICON_SIZE}
        fill={colors.brightBlue}
        viewBox={`0 0 ${AVERAGE_ICON_SIZE} ${AVERAGE_ICON_SIZE}`}
      >
        {/* Circle */}
        <Circle
          cx={`${AVERAGE_ICON_HALF}`}
          cy={`${AVERAGE_ICON_HALF}`}
          r='7'
          fill={colors.brightBlue}
        />
        {/* Circle border */}
        <Circle
          cx={`${AVERAGE_ICON_HALF}`}
          cy={`${AVERAGE_ICON_HALF}`}
          r='7'
          stroke='#fff'
          strokeWidth='2.5'
        />
        {/* Line through the center */}
        <Line x1='1' y1='15' x2='15' y2='1' stroke='#fff' strokeWidth='2.5' />
      </Svg>
    </div>
  )
}

export default AverageIcon
